import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AutoCompleteWithLabel } from 'commons/AutoComplete/AutoCompleteWithLabel';
import { DatePickerWithLabel } from 'commons/DatePicker/DatePickerWithLabel';
import { DialogType } from 'commons/Dialog/DialogTypes';
import { DialogWrapper } from 'commons/Dialog/DialogWrapper';
import { localize } from 'commons/LocalizedText/LocalizedText';
import { TextFieldWithLabel } from 'commons/TextFieldWithLabel/TextFieldWithLabel';
import { FileDropZone } from 'commons/Upload/FileDropzone';
import { isValidDate } from 'utils/processing/dates';

const useStyles = makeStyles((theme) => ({
  inputFields: {
    width: '300px',
    margin: '0'
  },
  content: {
    padding: '20px'
  }
}));

export const ProductTestUploadProviderBillDialog = ({ open, onClose, onSubmit, orderForms }) => {
  const classes = useStyles();
  const [file, setFile] = useState(null);
  const [providerBillRefNumber, setProviderBillRefNumber] = useState('');
  const [providerBillEmissionDate, setProviderBillEmissionDate] = useState(null);
  const [linkedOrderForms, setLinkedOrderForms] = useState([]);
  const orderFormOptions = [...orderForms];


  const handleDropZoneChange = newFile => (
    newFile && setFile(newFile)
  );

  const handleSubmit = () => {
    onSubmit(file,
      providerBillRefNumber,
      providerBillEmissionDate,
      linkedOrderForms.map(orderForm => orderForm.recid));
    handleClose();
  };

  const handleClose = () => {
    setFile(null);
    setProviderBillRefNumber('');
    setProviderBillEmissionDate(null);
    setLinkedOrderForms([]);
    onClose();
  };

  const preventSubmit = () => {
    return !file
      || !isValidDate(providerBillEmissionDate)
      || !providerBillRefNumber
      || linkedOrderForms.length === 0;
  }

  return (
    <DialogWrapper
      onClose={handleClose}
      onSubmit={handleSubmit}
      open={open}
      preventSubmit={preventSubmit()}
      title={localize("addNewProviderBill")}
      variant={DialogType.CONFIRMATION}
    >
      <Grid alignItems={'center'} className={classes.content} container direction={'column'} justifyContent={'center'}>
        <Grid item>
          <Grid alignItems={'center'} className={classes.content} container direction={'column'} justifyContent={'center'} spacing={2}>
            <Grid item>
              <TextFieldWithLabel
                enableColorChangeOnModification
                label='providerBillRefNumber'
                onChange={value => setProviderBillRefNumber(value)}
                value={providerBillRefNumber}
              />
            </Grid>
            <Grid item>
              <DatePickerWithLabel
                enableColorChangeOnModification
                label='providerBillEmissionDate'
                onChange={value => setProviderBillEmissionDate(value)}
                value={providerBillEmissionDate}
              />
            </Grid>
            <Grid item>
              <AutoCompleteWithLabel
                className={classes.inputFields}
                getOptionLabel={(option) => option.orderFormNumber}
                isMultiple
                label="linkedOrderForms"
                limitTags={-1}
                onChange={value => {setLinkedOrderForms(value)}}
                options={orderFormOptions}
                value={linkedOrderForms}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <FileDropZone onFileDrop={handleDropZoneChange} />
        </Grid>
      </Grid>
    </DialogWrapper>
  );
};